import { render, staticRenderFns } from "./WorkshopForm.vue?vue&type=template&id=70b59627"
import script from "./WorkshopForm.vue?vue&type=script&lang=js"
export * from "./WorkshopForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports